import { Brand, createBranded } from '@deltasierra/type-utilities';

export type CampaignMonitorReportSummaryId = Brand<number, 'CampaignMonitorReportSummaryId'>;
export const CampaignMonitorReportSummaryId = createBranded<CampaignMonitorReportSummaryId>();
